import DeviceEditButton from './DeviceEditButton'

export default DeviceEditButton
